import { render, staticRenderFns } from "./ScoreBarChart.vue?vue&type=template&id=950cce2c&"
import script from "./ScoreBarChart.vue?vue&type=script&lang=js&"
export * from "./ScoreBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports